import { LookupService } from '../../../core/services/lookup.service';
import {
  Component,
  OnInit,
  ViewContainerRef,
  Input,
  Renderer2,
  EventEmitter,
  Output,
  ComponentFactoryResolver,
  AfterViewInit
} from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import { NdmsTextboxComponent } from '../ndms-textbox/ndms-textbox.component';

@Component({
  selector: 'ndms-input',
  templateUrl: './ndms-input.component.html',
  styleUrls: ['./ndms-input.component.scss']
})
export class NdmsInputComponent extends NdmsFormControlComponent implements OnInit, AfterViewInit {

  @Input() type: string;
  @Input() foo: any;
  @Output() tabExit: EventEmitter<any>;

  public parentComponent: any;
  public componentRef: any;
  public initialFormArrayFormGroup: FormGroup;

  constructor(public vcRef: ViewContainerRef, renderer: Renderer2, private componentFactoryResolver: ComponentFactoryResolver) {
    super(vcRef);
    this.parentComponent = (<any>vcRef.injector).view.component;
    this.hasFormComponent = (<any>vcRef.injector).view.component;
  }

  ngOnInit() {
    // if (!this.type || this.type == 'text') {
    //   let componentFactory = this.componentFactoryResolver.resolveComponentFactory(NdmsTextboxComponent);

    //   this.vcRef.clear();
    //   this.componentRef = this.vcRef.createComponent(componentFactory, undefined, (<any>this.vcRef.parentInjector));
    //   this.componentRef.instance.label = this.label;
    //   this.componentRef.instance.field = this.field;
    //   this.componentRef.instance.group = this.group;
    // }
  }

  ngAfterViewInit(): void {
  }
}
